// Create our number formatter.
var formatter = new Intl.NumberFormat('en-GB', {
  style: 'currency',
  currency: 'GBP'

  // These options are needed to round to whole numbers if that's what you want.
  // minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
  // maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
})

export const itemSalesHeadings = (grouped, comparison) => {
  const headings = getCurrentHeadings(grouped, comparison)

  return headings
}

const getCurrentHeadings = (grouped, comparison) => {
  return getHeadings(grouped, comparison)
}

const getHeadings = (grouped, comparison) => {
  const headers = [
    {
      headerName: 'Barcode',
      field: 'barcode',
      filter: 'agTextColumnFilter'
    },
    {
      headerName: 'Product',
      field: 'product',
      filter: 'agTextColumnFilter'
    },
    {
      headerName: 'Category',
      field: 'category',
      rowGroup: grouped,
      filter: 'agSetColumnFilter',
      hide: grouped
    },
    {
      headerName: 'Qty',
      field: 'qty',
      filter: 'agNumberColumnFilter',
      aggFunc: sumColumn
    },
    {
      headerName: 'Gross',
      field: 'gross',
      sort: 'desc',
      filter: 'agNumberColumnFilter',
      aggFunc: sumColumn,
      valueFormatter: currencyFormatter,
      comparator: decimalValueComparator
    },
    {
      headerName: 'Net',
      field: 'net',
      filter: 'agNumberColumnFilter',
      aggFunc: sumColumn,
      valueFormatter: currencyFormatter,
      comparator: decimalValueComparator
    },
    {
      headerName: 'Gross Profit',
      field: 'profit',
      filter: 'agNumberColumnFilter',
      aggFunc: sumColumn,
      valueFormatter: currencyFormatter,
      comparator: decimalValueComparator
    },
    {
      headerName: 'Gross Margin',
      colId: 'margin',
      filter: 'agNumberColumnFilter',
      valueGetter: grossMarginGetter,
      valueFormatter: percentFormatter,
      aggFunc: grossMarginAgg,
      comparator: decimalStringValueComparator
    }
  ]

  if (comparison) {
    const compColour = 'lightcoral'
    const profitBgNegColour = 'lightcoral'
    const profitBgPosColour = 'lightgreen'

    headers.splice(4, 0, {
      headerName: 'Qty (C)',
      field: 'qtyc',
      filter: 'agNumberColumnFilter',
      aggFunc: sumColumn,
      cellStyle: { color: compColour },
      hide: true
    })

    headers.splice(6, 0, {
      headerName: 'Gross (C)',
      field: 'grossc',
      filter: 'agNumberColumnFilter',
      aggFunc: sumColumn,
      valueFormatter: currencyFormatter,
      comparator: decimalValueComparator,
      cellStyle: { color: compColour },
      hide: true
    })

    headers.splice(8, 0, {
      headerName: 'Net (C)',
      field: 'netc',
      filter: 'agNumberColumnFilter',
      aggFunc: sumColumn,
      valueFormatter: currencyFormatter,
      comparator: decimalValueComparator,
      cellStyle: { color: compColour },
      hide: true
    })

    headers.splice(10, 0, {
      headerName: 'Gross Profit (C)',
      field: 'profitc',
      filter: 'agNumberColumnFilter',
      aggFunc: sumColumn,
      valueFormatter: currencyFormatter,
      comparator: decimalValueComparator,
      cellStyle: { color: compColour }
    })

    headers.splice(12, 0, {
      headerName: 'Gross Margin (C)',
      colId: 'marginc',
      filter: 'agNumberColumnFilter',
      valueGetter: grossMarginGetterC,
      valueFormatter: percentFormatter,
      aggFunc: grossMarginAgg,
      comparator: decimalStringValueComparator,
      cellStyle: { color: compColour },
      hide: true
    })

    headers.push({
      headerName: 'Profit Diff',
      colId: 'profitdiff',
      filter: 'agNumberColumnFilter',
      valueGetter: profitDiffGetter,
      valueFormatter: percentFormatter,
      aggFunc: profitDiffAgg,
      comparator: decimalStringValueComparator,
      cellStyle: params => {
        if (params.value === '-' || params.value === 0) {
          return null
        } else if (params.value > 0) {
          return { backgroundColor: profitBgPosColour }
        } else {
          return { backgroundColor: profitBgNegColour }
        }
      }
    })
  }

  return headers
}

function profitDiffGetter (params) {
  if (!params.node.group) {
    return {
      profit: params.data.profit,
      profitc: params.data.profitc,
      toString: () => params.data.profit !== '-' && params.data.profitc !== '-' && params.data.profitc !== 0 ? ((params.data.profit - params.data.profitc) / Math.abs(params.data.profitc)) * 100 : '-'
    }
  }
}

function grossMarginGetterC (params) {
  if (!params.node.group) {
    return {
      net: params.data.netc,
      profit: params.data.profitc,
      toString: () => params.data.profitc !== '-' && params.data.netc !== 0 ? (params.data.profitc / params.data.netc * 100) : '-'
    }
  }
}

function grossMarginGetter (params) {
  if (!params.node.group) {
    return {
      net: params.data.net,
      profit: params.data.profit,
      toString: () => params.data.profit !== '-' && params.data.net !== 0 ? (params.data.profit / params.data.net * 100) : '-'
    }
  }
}

const profitDiffAgg = (params) => {
  var profitSum = 0
  var profitcSum = 0
  params.values.forEach(value => {
    if (value && value.profit !== '-' && value.profitc !== '-') {
      profitSum += value.profit
      profitcSum += value.profitc
    }
  })
  return {
    toString: () => {
      return profitcSum !== 0 ? ((profitSum - profitcSum) / Math.abs(profitcSum)) * 100 : '-'
    }
  }
}

const grossMarginAgg = (params) => {
  var netSum = 0
  var profitSum = 0
  params.values.forEach(value => {
    if (value && value.profit !== '-') {
      netSum += value.net
      profitSum += value.profit
    }
  })
  return {
    toString: () => {
      return profitSum !== 0 && netSum !== 0 ? (profitSum / netSum * 100) : '-'
    }
  }
}

// Function to used to compare numbered values
const decimalValueComparator = (valueA, valueB) => {
  if (valueA === undefined || valueB === undefined) {
    return 0
  }

  if (valueA === '-') {
    valueA = '0'
  }

  if (valueB === '-') {
    valueB = '0'
  }

  return (valueA < valueB) ? -1 : 1
}

const decimalStringValueComparator = (valueA, valueB) => {
  valueA = valueA.toString()
  valueB = valueB.toString()

  if (valueA === undefined || valueB === undefined) {
    return 0
  }

  if (valueA === '-') {
    valueA = '0'
  }

  if (valueB === '-') {
    valueB = '0'
  }

  return (parseFloat(valueA) < parseFloat(valueB)) ? -1 : 1
}

// Used to aggregate columns when grouped together
const sumColumn = (params) => {
  let sum = 0
  const values = params.values

  values.forEach(function (value) {
    if (value !== '-') {
      sum += value
    }
  })

  if (sum === 0) {
    return '-'
  } else {
    return Math.round(sum * 100) / 100
  }
}

function currencyFormatter (params) {
  if (params.value !== '-') {
    params.value = formatter.format(params.value)
    return params.value
  }
}

function percentFormatter (params) {
  const value = params.value.toString()
  if (value !== '-') {
    params.value = value.toFixed(2) + ' %'
    return params.value
  }
}
